var CollectionView = require('views/base/collection-view');
var View = require('views/base/view');

var ModuleCollectionView = CollectionView.extend({
  autoRender: true,
  template: require('./templates/module-collection'),
  itemView: require('./module-item-view'),
  listSelector: '.module-items',
  animationDuration: 0,
  initItemView: function(model) {
    return new this.itemView({
      autoRender: false,
      model: model,
      moduleClass: this.model.get('moduleClass'),
      useDiv: this.model.get('use_div'),
      moduleTemplate: this.model.get('module_template')
    });
  },
  getTemplateData: View.prototype.getTemplateData
});

module.exports = ModuleCollectionView;
